import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const HomeMadeItemsOwnerView = () => {
    return (
        <div>
            <ShopItemsView update="/homemade-item-update" deleteurl="/home-made-owner-profile" urlone="/homemadeownerprofile"/>
        </div>
    )
}
export default HomeMadeItemsOwnerView;